<template>
    <b-media vertical-align="center">
        <!-- AVATAR -->
        <b-link :to="`/v2/profile/${post.user.id}`" slot="aside">
            <avatar :size="42" :src="post.user.picture" :username="post.user.name" class="hidden-sm-down" />
        </b-link>
        <!-- CABECALHO PEQUENO -->
        <PostHeader :post="post" />
        <!-- TITULO -->
        <PostTitle :post="post" class="text-truncate font-weight-bold mb-1 mt-1 ml-1" />
        <!-- CONTEUDO -->
        <div class="ml-2 text-muted">
            <!-- OKR -->
            <PostContentOKRCheckin :post="post" v-if="isOKRCheckin" />
            <!-- GOAL -->
            <PostContentGoal :post="post" v-if="isGoal" />

            <PostContentActionPlan :post="post" v-if="isPDI" />

            <!-- NETWORK -->
            <PostContentNetwork :post="post" v-if="isNetwork" />
            <!-- ATUALIZAÇÃO DE ETAPA -->
            <PostContentStage :post="post" v-if="isUser" />
            <!-- ASSUNTO -->
            <PostContentValue :post="post" v-if="isValue" />
            <!-- COMENTARIO -->
            <PostComment :post="post" v-if="post.operation == 'comment'" />
            <!-- EDIÇÃO EM MASSA -->
            <div v-if="post.operation === 'users_bulk_edit'">
                <span v-html="$t('usersBulkEdit.messages.massUpdateSuccessfullyProcessed')" />
            </div>
        </div>
    </b-media>
</template>

<script>
import Avatar from 'vue-avatar'
import { getUserPermissions } from '@/services/user-permissions'
import {
    PostTitle,
    PostHeader,
    PostContentOKRCheckin,
    PostContentGoal,
    PostContentNetwork,
    PostContentStage,
    PostContentValue,
    PostComment,
    PostContentActionPlan,
} from './components'
import { downloadEvidenceMixin, artifactTypeMixin } from '@/mixins'

export default {
    name: 'FeedPost',
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    mixins: [downloadEvidenceMixin, artifactTypeMixin],
    data() {
        return {
            permissions: getUserPermissions(),
        }
    },
    components: {
        Avatar,
        PostTitle,
        PostHeader,
        PostContentOKRCheckin,
        PostContentGoal,
        PostContentNetwork,
        PostContentStage,
        PostContentValue,
        PostComment,
        PostContentActionPlan,
    },
}
</script>
<style scoped>
button:disabled {
    cursor: not-allowed !important;
    pointer-events: all !important;
}
::v-deep .field {
    font-weight: 500;
}
</style>
